import { useMemo } from "react";
import { useBranchLimits } from "../../BranchLimits";
import { useAccount } from "../../Account";
import { useLocationConfiguration } from "../../LocationConfiguration";

const getValidPatronBranch = function (
  issuingBranch: number,
  locationIds: string[]
) {
  if (issuingBranch) {
    const issuingBranchAsString = issuingBranch.toString();
    // patron issuing branch may not be in the config
    if (locationIds.includes(issuingBranchAsString)) {
      return issuingBranchAsString;
    }
  }
  return null;
};

export function usePatronLocation() {
  const { displayInPickupLocationIds, displayInCopiesBranchIds } =
    useBranchLimits();
  const { locationConfiguration } = useLocationConfiguration();
  const { pacSettings } = locationConfiguration || {};
  const { userActionSettings } = pacSettings || {};
  const { useUsersBranchForAvailability } = userActionSettings || {};
  const { patron } = useAccount();
  const { issuingBranch } = patron || {};

  const patronLocation = useMemo(() => {
    const shelfLocation = getValidPatronBranch(
      issuingBranch,
      displayInCopiesBranchIds
    );

    // TODO is displayInPickupLocationIds always the same as displayInCopiesBranchIds?
    const pickupLocation = getValidPatronBranch(
      issuingBranch,
      displayInPickupLocationIds
    );

    return {
      shelfLocation: useUsersBranchForAvailability ? shelfLocation : null,
      availabilityLocation: useUsersBranchForAvailability
        ? shelfLocation
        : null,
      pickupLocation: pickupLocation,
    };
  }, [
    displayInPickupLocationIds,
    displayInCopiesBranchIds,
    issuingBranch,
    useUsersBranchForAvailability,
  ]);

  return patronLocation;
}
